module.exports = __webpack_public_path__ + "img/default-service.2c1fcd1c.png";